import { styled } from "@linaria/react";
import { color } from "..";

/**
 * Consists in 4 backgrounds:
 * - 2 shadows attached to scroll container
 * - 2 shadow covers attached to scrolled element in order to hide shadow when it needs
 */

interface P extends React.HTMLAttributes<HTMLDivElement> {
  backgroundColor?: string;
}

const ShadowedScrollArea = styled.div<P>`
  overflow-y: auto;
  background: 
    /* shadow cover top */
    linear-gradient(
      ${props => props.backgroundColor ?? color.hydrogen} 30%,
      ${color.hydrogenFade90}
    ),
    /* shadow cover bottom */
      linear-gradient(
        ${color.hydrogenFade90},
        ${props => props.backgroundColor ?? color.hydrogen} 70%
      )
      0 100%,
    /* shadow top */
      radial-gradient(farthest-side at 50% 0, ${color.carbon900Fade90}, ${color.hydrogenFade90}),
    /* shadow bottom */
      radial-gradient(farthest-side at 50% 100%, ${color.carbon900Fade90}, ${color.hydrogenFade90})
      0 100%;

  background-repeat: no-repeat;
  background-size:
    100% 40px,
    100% 40px,
    100% 14px,
    100% 14px;
  /* Opera doesn't support this in the shorthand */
  background-attachment: local, local, scroll, scroll;
`;

export default ShadowedScrollArea;
